import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ticketService } from '../services/ticketService';
import { PurchaseTicketData } from '../types';
import toast from 'react-hot-toast';

export const usePurchaseTicket = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data: PurchaseTicketData) => ticketService.purchaseTicket(data),
    onSuccess: (response) => {
      // If payment is required, the component handles the Paystack popup or redirect
      if (response.data.requiresPayment && response.data.paymentData) {
        return; // Let the component handle payment flow
      }
      
      // If no payment required, tickets were purchased successfully (wallet payment)
      queryClient.invalidateQueries({ queryKey: ['tickets'] });
      queryClient.invalidateQueries({ queryKey: ['wallet'] });
      queryClient.invalidateQueries({ queryKey: ['raffles'] });
      toast.success('Ticket purchased successfully!');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.message || 'Failed to purchase ticket');
    },
  });
};

export const useMyTickets = (params?: { page?: number; limit?: number; raffleId?: string; status?: string; startDate?: string; endDate?: string }) => {
  return useQuery({
    queryKey: ['tickets', 'my', params],
    queryFn: () => ticketService.getMyTickets(params),
  });
};

export const usePurchaseHistory = (params?: { page?: number; limit?: number }) => {
  return useQuery({
    queryKey: ['tickets', 'history', params],
    queryFn: () => ticketService.getPurchaseHistory(params),
  });
};
